<template>
  <v-dialog v-model="shown" v-if="!hasBeenShown" persistent eager width="600">
    <v-card>
      <v-card-text>
        <div class="videoWrapper">
          <iframe
            frameBorder="0"
            scrolling="yes"
            seamless="seamless"
            sandbox="allow-scripts"
            :src="
              `https://storage.googleapis.com/changeloggy.appspot.com/mail_switch.html`
            "
          ></iframe>
        </div>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="close" color="primary">close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style scoped>
.videoWrapper {
  position: relative;
  padding-bottom: 56.25%; /* 16:9 */
  padding-top: 25px;
  height: 0;
}
.videoWrapper iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>

<script>
export default {
  data: () => ({
    shown: false,
    version: "",
  }),

  methods: {
    close() {
      this.shown = false;
      localStorage.setItem(this.version, "true");
    },

    async recieveVersion() {
      return new Promise((resolve) => {
        var eventMethod = window.addEventListener
          ? "addEventListener"
          : "attachEvent";
        var eventer = window[eventMethod];
        var messageEvent =
          eventMethod == "attachEvent" ? "onmessage" : "message";

        eventer(
          messageEvent,
          function(e) {
            if (e.data.type === "VERSION") {
              resolve(e.data.value);
            }
          },
          false
        );
      });
    },
  },

  computed: {
    hasBeenShown() {
      return localStorage.getItem(this.version) === "true";
    },
  },

  async mounted() {
    this.version = await this.recieveVersion();

    if (!this.hasBeenShown) {
      this.shown = true;
    }
  },
};
</script>
